import { render, staticRenderFns } from "./penerimaanEdit.vue?vue&type=template&id=6cab6ee1&scoped=true"
import script from "./penerimaanEdit.vue?vue&type=script&lang=js"
export * from "./penerimaanEdit.vue?vue&type=script&lang=js"
import style0 from "./penerimaanEdit.vue?vue&type=style&index=0&id=6cab6ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab6ee1",
  null
  
)

export default component.exports